module.exports = "./img/5bf7055b646f394bcc9c28be81fef874.jpg";